import { useCallback } from "react";

const usePriorityChange = ({
  api,
  taskId,
  task,
  setTask,
  setShowPriorityDropdown,
}) => {
  return useCallback(
    async (priorityValue) => {
      if (!priorityValue) return;

      try {
        await api.task.updateTask(taskId, {
          priority: priorityValue,
          version: task.version,
        });
        const updatedTask = await api.task.getTaskById(taskId);
        setTask(updatedTask);
      } catch (error) {
        console.error("Error updating task priority:", error);
      } finally {
        setShowPriorityDropdown?.(false);
      }
    },
    [api, taskId, task, setTask, setShowPriorityDropdown]
  );
};

export default usePriorityChange;
